/** */

import { EmailService } from 'src/app/services/integrations/email/email.service';
import { ToastrService } from 'ngx-toastr';

class EmailHelper {

    //
    loading: boolean = false;
    is_connected: boolean = false;
    user_data: any = {};

    constructor(
        private email_service: EmailService,
        private toast: ToastrService,
    ) {
        this.email_service.user_data.subscribe(data => {
            if (!Object.keys(data).length) return;
            this.user_data = { ...data };
        });
    }

    retrieve_connected_account() {
        this.email_service.fetchAccessTokenDataFromServer().subscribe((response: any) => {
            if (response.success && response.status_code === 200) {
                this.email_service.user_data.next({ ...response.payload[0] });
                this.user_data = { ...response.payload[0] };
                this.is_connected = this.user_data.is_active;
            }
        }, err => {
        })
    }

    async retrieve_account() {
        await this.email_service.fetchAccessTokenDataFromServer().subscribe((response: any) => {
            if (response.success && response.status_code === 200) {
                this.email_service.user_data.next({ ...response.payload[0] });
                this.user_data = { ...response.payload[0] };
                this.is_connected = true;
            }
        }, err => {
        })
    }

    disconnect_account() {
        this.loading = true;
        this.email_service.revokeUserAccess(this.user_data.id).subscribe((response: any) => {
            this.loading = false;
            if (response.success && response.status_code === 200) {
                this.email_service.user_data.next({});
                this.user_data = {};
                this.is_connected = false;
                this.toast.success('Account disconnected');
            } else {
                this.toast.error('Could not disconnect account.')
            }
        }, error => {
            this.loading = false;
        })
    }
}

export default EmailHelper;